const ProductModal = {

    showDescriptionNutritionOrIngredients(e, identifier) {
        if (e.classList.contains('selected')) return;

        let parent = e.parentElement;
        let grandparent = parent.parentElement;

        // set the 'selected' class onto the selected button, remove from others
        for (let id of ['description', 'nutrition', 'ingredients']) {
          if (identifier == id) {
            e.classList.add('selected');
            grandparent.getElementsByClassName(id)[0].style.display = 'block';
          } else {
            parent.getElementsByClassName(id + '-btn')[0].classList.remove('selected');
            grandparent.getElementsByClassName(id)[0].style.display = 'none';
          }
        }
    },

    addToBox(e, checkoutBuild, id, image_url, name, point_value, summation) {
        checkoutBuild.addToBox(id, image_url, name, point_value, summation);
        e.parentElement.parentElement.parentElement.style.display = 'none';
    },

};

export default ProductModal;